(function () {
  function initPremiumIncluded(section) {
    if (!section || section.dataset.premiumIncludedInit === 'true') return;

    section.dataset.premiumIncludedInit = 'true';

    var items = Array.prototype.slice.call(section.querySelectorAll('.premium-included__item'));

    if (!items.length) return;

    function setPanelHeight(item) {
      var panel = item.querySelector('.premium-included__panel');

      if (!panel) return;

      if (item.classList.contains('is-active')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.style.maxHeight = '0px';
      }
    }

    function closeItem(item) {
      var button = item.querySelector('.premium-included__button');

      item.classList.remove('is-active');

      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }

      setPanelHeight(item);
    }

    function openItem(item) {
      var button = item.querySelector('.premium-included__button');

      item.classList.add('is-active');

      if (button) {
        button.setAttribute('aria-expanded', 'true');
      }

      setPanelHeight(item);
    }

    function closeAllExcept(activeItem) {
      items.forEach(function (item) {
        if (item !== activeItem) {
          closeItem(item);
        }
      });
    }

    items.forEach(function (item, index) {
      var button = item.querySelector('.premium-included__button');

      if (index === 0) {
        item.classList.add('is-active');
        if (button) button.setAttribute('aria-expanded', 'true');
      } else {
        item.classList.remove('is-active');
        if (button) button.setAttribute('aria-expanded', 'false');
      }

      setPanelHeight(item);

      if (!button) return;

      button.addEventListener('click', function () {
        var isActive = item.classList.contains('is-active');

        if (isActive) {
          closeItem(item);
          return;
        }

        closeAllExcept(item);
        openItem(item);
      });
    });

    window.addEventListener('resize', function () {
      items.forEach(setPanelHeight);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-visible');
            observer.unobserve(section);
          }
        });
      }, {
        threshold: 0.18
      });

      observer.observe(section);
    } else {
      section.classList.add('is-visible');
    }
  }

  function initAllPremiumIncluded() {
    var sections = document.querySelectorAll('.js-premium-included');
    sections.forEach(initPremiumIncluded);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPremiumIncluded);
  } else {
    initAllPremiumIncluded();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.js-premium-included');
    initPremiumIncluded(section);
  });
})();